import React, { InputHTMLAttributes } from 'react';
import styles from './Checkbox.module.scss';
interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  className?: string;
  id?: string;
  data_cy?: string;
}
const Checkbox: React.FC<CheckboxProps> = ({
  label,
  className = '',
  id,
  data_cy,
  ...props
}) => {
  return <label className={`${styles['checkbox']} ${props.disabled ? styles['checkbox-disabled'] : ''}  ${className}`} id={id} data-cy={data_cy} data-sentry-component="Checkbox" data-sentry-source-file="Checkbox.tsx">
      <span className={styles['checkbox-section']}>
        <input {...props} type="checkbox" className={`${styles['checkbox-input']}`} />
        <span className={styles['checkbox-label']}></span>
        <span className={styles['checkbox-hover']}></span>
      </span>
      <span className={styles['label']}>{label}</span>
    </label>;
};
export default Checkbox;